const rooster = {
  helpWrapper: {
    // border: '1px solid red',
    width: '100%',
    textAlign: 'left',
    fontSize: '0.7em',
    padding: '15px',
  },
  helpHeader: {
    fontWeight: 'bold',
    color: '#616161',
  },
  td: {
    // border: '1px solid red',
    padding: '15px',
    width: '30%',
    verticalAlign: 'middle',
  },
  stepNumber: {
    fontSize: '3em',
    fontWeight: 'bold',
    verticalAlign: 'middle',
    textAlign: 'right',
    padding: '15px',
    paddingRight: 0,
  },
  td1: {
    color: '#32d7bb',
  },
  td2: {
    color: '#90CAF9',
  },
  td3: {
    color: '#9FA8DA',
  },
  variablesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    height: '75px',
    marginBottom: '20px',
  },
  variablesHeader: {
    fontWeight: 600,
    marginTop: '10px',
  },
  variableItem: {
    fontSize: '11px',
  },
}

const tops = {
  helpWrapper: {
    width: '100%',
    textAlign: 'left',
    fontSize: '0.7em',
    padding: '15px',
  },
  helpHeader: {
    fontWeight: 'bold',
    color: '#616161',
  },
  td: {
    padding: '15px',
    width: '30%',
    verticalAlign: 'middle',
    backgroundColor: '#cacaca',
    borderRadius: '5px',
  },
  stepNumber: {
    fontSize: '3em',
    fontWeight: 'bold',
    verticalAlign: 'middle',
    textAlign: 'right',
    padding: '15px',
  },
  td1: {
    color: '#32d7bb',
  },
  td2: {
    color: '#90CAF9',
  },
  td3: {
    color: '#9FA8DA',
  },
  variablesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    height: '75px',
    marginBottom: '20px',
  },
  variablesHeader: {
    fontWeight: 600,
    marginTop: '10px',
  },
  variableItem: {
    fontSize: '11px',
  },
}

module.exports = process.env.REACT_APP_IS_TOPS ?
  tops :
  rooster



// WEBPACK FOOTER //
// ./src/components/Settings/styles/Help.js